import type React from 'react';
import { useContext, useRef } from 'react';
import type { BaseAdConfig, PageAdConfig } from 'interfaces/ads/Ad';
import ADS_TEST_IDS from 'constants/testsIds/ads';
import { UserContext } from 'providers/UserProvider';
import { useDirectSoldFallback } from '@/app_lib/hooks/useDirectSoldFallback';
import { LeaderboardAd } from './Styles';
import AdSlotToggle from './AdSlotToggle';

interface LeaderboardProps extends BaseAdConfig {
  pageAdConfig?: PageAdConfig;
}

const Leaderboard: React.FC<LeaderboardProps> = ({ id, pageAdConfig }) => {
  const { personalizedAds } = useContext(UserContext);
  const containerRef = useRef<HTMLDivElement>(null);

  useDirectSoldFallback(personalizedAds === false ? pageAdConfig?.ch : undefined, pageAdConfig?.ctype, containerRef);

  return (
    <div
      ref={containerRef}
      className='leaderboard-direct-sold-fallback-root'
      style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
    >
      <AdSlotToggle
        component={LeaderboardAd}
        placementName='Leaderboard'
        slotId={`Leaderboard${id}`}
        index={id + 1}
        dataCy={ADS_TEST_IDS.LEADERBOARD}
      />
    </div>
  );
};

export default Leaderboard;
